define('gameday-language/dictionary',['require','exports','module','mustache-language/dictionary','./languages/es'],function(require,exports,module){
    var dictionary = require( "mustache-language/dictionary" ),
        es = require("./languages/es");

    dictionary.set('es',es);

    return dictionary;
}); 

